var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-text"},[_c('div',{staticClass:"text",style:({ animationDuration: _vm.duration + 's' })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }